<section aria-labelledby="modalHeaderId" class="modal-template">
  <header *ngIf="modalHeader"
          class="modal-template-header">
    <h1 id="modalHeaderId" *ngIf="!isHeaderTemplateRef; else headerTemplate" class="modal-template-header-text h2" tabindex="-1"
        [innerHTML]="modalHeader">
    </h1>
    <ng-template #headerTemplate>
      <ng-container [ngTemplateOutlet]="modalHeaderRef" class="modal-template-header-text"></ng-container>
    </ng-template>
    <zbp-button-component
      *ngIf="showCloseX"
      [iconName]="zbpIconNames.x_cross"
      class="x_cross control-button"
      (clickHandler)="dismiss()"
      [ariaLabel]="'Close Modal'"
      theme="icon">
    </zbp-button-component>
  </header>
  <div *ngIf="bodyContent"
       class="modal-template-body-content"
       [class.is-scrollable]="isScrollable">
    <ng-container [ngTemplateOutlet]="bodyContent"></ng-container>
  </div>
  @if (footerContent) {
    <footer class="modal-template-footer-content">
      <div class="modal-template-footer-content-left">
        <ng-container [ngTemplateOutlet]="footerLeftContent"></ng-container>
      </div>
      <div class="modal-template-footer-content-right">
        <ng-container [ngTemplateOutlet]="footerContent"></ng-container>
      </div>
    </footer>
  } @else if (footerContentFull) {
    <footer class="modal-template-footer-content-full">
      <div class="modal-template-footer-content-full-template">
        <ng-container [ngTemplateOutlet]="footerContentFull"></ng-container>
      </div>
    </footer>
  }
</section>
